<!--
 * @模块组件?公共组件: 组件中文名
 * @Comp: <组件名称>
 * @desc: 组件描述
 * @author: 叶锦全
 * @Date: 2022-09-14 12:18:47
 * @param: {Number} [paramName: notRequired?required] - 参数说明
 * @example: 调用示例
 * <compm :param='' @xxx=''></comp>
 * @LastEditors: 叶锦全
 * @LastEditTime: 2022-09-14 13:03:45
-->
<template>
  <div class="xiaxin_msgs">
    <sub-layout-one :navList="navList" :defaultSelect="navList.data[currentId]" @itemSelect="itemSelect"></sub-layout-one>
  </div>
</template>
<script>
import subLayoutOne from './common/subLayoutOne.vue'
export default {
  components: { subLayoutOne },
  data () {
    return {
      currentId: 0,
      navList: {
        title: '信息公开',
        data: [
          {
            id: 0,
            icon: 'appstore',
            name: '协会文件',
            show_sub: false,
            path: '/home/public_info',
            sons: []
          }]
      }
    }
  },
  created () {
  },
  methods: {
    itemSelect (item) {
      console.log(item)
      this.currentId = item.id
    }
  }
}
</script>
